export default {
  needHelp: 'Besoin d\'aide?',
};
